import React, { useCallback } from 'react';
import { useEventTracker } from '@applyboard/ui-utils';
import { Accordion, Box, SectionSpacer, StyledRawHtml } from '@applyboard/ui-components';
export function PostGraduationPermit(_ref) {
  var pgwpTextHtml = _ref.pgwpTextHtml,
    title = _ref.title;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var handleOnToggleOpen = useCallback(function () {
    trackEvent({
      event: 'Programs Page - Clicked PostGraduationPermit Drop-Down'
    });
  }, [trackEvent]);
  return /*#__PURE__*/React.createElement(Accordion, {
    onToggleOpen: handleOnToggleOpen,
    items: [{
      title: title,
      content: /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(SectionSpacer, null, /*#__PURE__*/React.createElement(StyledRawHtml, {
        html: pgwpTextHtml
      }))),
      expanded: true
    }]
  });
}